import { useQueryShoppingStores } from '@/features/shop/services/ShoppingStore/queries'
import { useStoreId } from '@/features/account/services/User/hooks'
import { useCallback } from 'react'
import { type ShoppingStoresResponse } from '@/features/shop/services/ShoppingStore/types'

export const useDeliveryStores = () => {
  const { data } = useQueryShoppingStores()

  return data?.delivery_stores ?? []
}

export const usePickupStores = () => {
  const { data } = useQueryShoppingStores()
  return data?.pickup_stores ?? []
}

export const useUserStoreLocationName = () => {
  const storeId = useStoreId()
  const deliveryStores = useDeliveryStores()
  return deliveryStores.find((s) => s.id === storeId)?.store_location_name
}

export const useDeliveryStoreById = (id: number | null) => {
  const deliveryStores = useDeliveryStores()
  if (!id) return undefined
  const store = deliveryStores.find((ds) => ds.id === id)
  return store
}

export const useUserShoppingStore = () => {
  const storeId = useStoreId()
  const selectFn = useCallback(
    (data: ShoppingStoresResponse) =>
      data.delivery_stores.find((store) => store.id === storeId),
    [storeId]
  )
  return useQueryShoppingStores({
    isDisabled: !storeId,
    selectFn,
  })
}
